import { render, staticRenderFns } from "./AppHeaderFake.vue?vue&type=template&id=44ff37f6&"
import script from "./AppHeaderFake.vue?vue&type=script&lang=js&"
export * from "./AppHeaderFake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports